export const elzbietaKuleszko = {
    'mydrId': 'elżbietakuleszko',
    'firstName': 'Elżbieta',
    'lastName': 'Kuleszko',
    'profession': 'Psycholog, psychoterapeuta, psychotraumatolog',
    'avatar': 'elzbieta-kuleszko.webp',
    'slug': 'psycholog-psychoterapeuta-psychotraumatolog-elzbieta-kuleszko',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'parents'],
        ['psychoterapy', 'emdr'],
        ['psychology', 'consultation'],
    ]
}